module.exports = __webpack_public_path__ + "img/audio.93c7fd4a.png";